/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Buy_Messages_Modal_Custom_Input_PlaceholderInputs */

const es_components_buy_messages_modal_custom_input_placeholder = /** @type {(inputs: Components_Buy_Messages_Modal_Custom_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ej: 250`)
};

const en_components_buy_messages_modal_custom_input_placeholder = /** @type {(inputs: Components_Buy_Messages_Modal_Custom_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. 250`)
};

/**
* | output |
* | --- |
* | "e.g. 250" |
*
* @param {Components_Buy_Messages_Modal_Custom_Input_PlaceholderInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_buy_messages_modal_custom_input_placeholder = /** @type {((inputs?: Components_Buy_Messages_Modal_Custom_Input_PlaceholderInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Buy_Messages_Modal_Custom_Input_PlaceholderInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_buy_messages_modal_custom_input_placeholder(inputs)
	return en_components_buy_messages_modal_custom_input_placeholder(inputs)
});
export { components_buy_messages_modal_custom_input_placeholder as "components.buy_messages_modal.custom.input_placeholder" }